(() => {
  function init(root = document) {
    root.querySelectorAll('[data-sb-service]').forEach(select => {
      if (select.dataset.sbReady) return;
      select.dataset.sbReady = 'true';
      const form = select.closest('form');
      const params = new URLSearchParams(window.location.search);
      const service = params.get('service');
      const options = Array.from(select.options);
      if (!select.value && options.some(option => option.value === service)) select.value = service;
      const packageKey = params.get('package');
      const allowed = ['professional', 'signature', 'team_bank'];
      const packageField = form.querySelector('[data-sb-package]');
      const packageLabel = allowed.includes(packageKey) ? form.querySelector(`[data-sb-package-label="${packageKey}"]`) : null;
      if (packageLabel && select.value === 'portraits') packageField.value = packageLabel.value;
      function showSelection() {
        if (select.value !== 'portraits') packageField.value = '';
        const panel = form.querySelector('[data-sb-context]');
        const selected = options.find(option => option.value === select.value);
        panel.hidden = !select.value;
        form.querySelector('[data-sb-selection]').textContent = packageField.value || selected?.textContent || '';
        form.querySelector('[data-sb-bank-note]').hidden = !(packageKey === 'team_bank' && select.value === 'portraits');
      }
      select.addEventListener('change', showSelection);
      showSelection();
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init()); else init();
  document.addEventListener('shopify:section:load', event => init(event.target));
})();
